import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import CityLanding from "@/pages/CityLanding";
import Careers from "@/pages/Careers";
import Admin from "@/pages/Admin";
import Portal from "@/pages/Portal";
import SupplyStore from "@/pages/SupplyStore";
import TimeClock from "@/pages/TimeClock";
import PaymentSuccess from "@/pages/PaymentSuccess";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/commercial-cleaning/:slug" element={<CityLanding />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/supply" element={<SupplyStore />} />
          <Route path="/clock" element={<TimeClock />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
